import step1 from '../../assets/new-ui/mint/mint-gen-1.png'
import step2 from '../../assets/new-ui/mint/mint-gen-2.png'
import step3 from '../../assets/new-ui/mint/mint-gen-3.png'
import step4 from '../../assets/new-ui/mint/mint-gen-4.png'
import step5 from '../../assets/new-ui/mint/mint-gen-5.png'
export default function GuideStep() {
  return (
    <div className='guideStepContainer'>
      <div className='step step1'>
        <div className='title'>
          <div>1</div>
          <div>Firstly, connect your wallet using the button displayed on the page:</div>
        </div>
        <img src={step1} alt='guide step'/>
      </div>

      <div className='step step2'>
        <div className='title'>
          <div>2</div>
          <div>Select whichever wallet extension you prefer to connect: </div>
        </div>
        <img src={step2} alt='guide step'/>
      </div>

      <div className='step step3'>
        <div className='title'>
          <div>3</div>
          <div>Once you've approved your wallet to access the page, you should see the mint button:</div>
        </div>
        <img src={step3} alt='guide step'/>
      </div>

      <div className='step step4'>
        <div className='title'>
          <div>4</div>
          <div>Finally, approve the transaction that pops up. If your minting is successful, you can view your transaction details through a message that will show up shortly.</div>
        </div>
        <img src={step4} alt='guide step'/>
      </div>

      <div className='step step5'>
        <div className='title'>
          <div>5</div>
          <div>You can now see your sharks in My NFTs page</div>
        </div>
        <img src={step5} alt='guide step'/>
      </div>
    </div>
  )
}